import { getDocs, query, collection, where } from 'firebase/firestore';
import { db } from '../firebase';
import moment from 'moment';

export const checkAbsenceDay = async (userId, date) => {
  const dateMoment = moment(date, 'DD/MM/YYYY');
  const year = dateMoment.format('YYYY');

  const absencesQuery = query(collection(db, 'users', userId, 'ausencias'), where('status', '==', 'Aceptado'), where('year', '==', year));

  const absences = await getDocs(absencesQuery);

  for (const doc of absences.docs) {
    const absence = doc.data();
    const start = moment(absence.startDate, 'DD/MM/YYYY');
    const end = moment(absence.endDate, 'DD/MM/YYYY');

    if (dateMoment.isSameOrAfter(start) && dateMoment.isSameOrBefore(end)) {
      return true;
    }
  }

  return false;
};
